import { FC, ReactNode } from "react";
import { ClockIcon, PeopleIcon } from "shared/ui/icons";
import { formatRaffleDate } from "./formatRaffleDate";
import { RaffleTimer } from "./RaffleTimer";

import styles from "./RaffleCard.module.css";

interface Props {
  participantsCount: number;
  endsAt: string;
  drawnAt?: string;
  // Готовое значение вместо живого таймера (превью несозданного розыгрыша).
  timeLeft?: string;
}

const Stat: FC<{ icon: ReactNode; label: string; children: ReactNode }> = ({
  icon,
  label,
  children,
}) => (
  <span className={styles.stat}>
    {icon}
    <span className={styles.statText}>
      <span className={styles.label}>{label}</span>
      <span className={styles.value}>{children}</span>
    </span>
  </span>
);

export const RaffleCardStats: FC<Props> = ({
  participantsCount,
  endsAt,
  drawnAt,
  timeLeft,
}) => (
  <span className={styles.stats}>
    <Stat icon={<PeopleIcon className={styles.icon} />} label="Participants">
      {participantsCount}
    </Stat>
    {drawnAt ? (
      <Stat icon={<ClockIcon className={styles.icon} />} label="Drawn">
        {formatRaffleDate(drawnAt)}
      </Stat>
    ) : (
      <Stat icon={<ClockIcon className={styles.icon} />} label="Time left">
        {timeLeft ?? <RaffleTimer endsAt={endsAt} />}
      </Stat>
    )}
  </span>
);
